<template>
  <div class="matter-articles">
    <div v-for="(col, idx) in columns" :key="idx" class="matter-articles__column">
      <template v-for="(item, j) in col">
        <ArticleTile :item="item" :key="j" />
      </template>
    </div>
  </div>
</template>

<script>
import ArticleTile from '@/components/matter/ArticleTile';
import { BreakPoints as bp } from '@/app-constants';

export default {

  props: ['articles'],

  components: { ArticleTile },

  computed: {

    columns() {
      const articles = this.articles;
      const device = this.$store.getters.deviceType;
      let columnCount = 0;
      switch (device) {
        case bp.desktop.key:
          columnCount = 3;
          break;
        case bp.tablet.key:
          columnCount = 2;
          break;
        case bp.mobile.key:
        default:
          columnCount = 1;
          break;
      }

      /*
        two dimensional array
        column containers
        column stories
      */
      const columns = [];

      for (let i = 0; i < articles.length; i += 1) {
        const col = i % columnCount;
        if (!columns[col]) {
          columns[col] = [];
        }

        columns[col].push(articles[i]);
      }

      return columns;
    },

  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_typography.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';

.matter-articles {
  background: $color--quaternary-midtone;

  // media query props
  @include ngGrid('mobile');
  padding: 0;
  padding-top: rem(50px);
  padding-bottom: rem(80px);

  @include ngMq($nbp--tablet, up) {
    @include ngGrid('tablet');
    padding-top: rem(50px);
    padding-bottom: rem(150px);
  }

  @include ngMq($nbp--desktop, up) {
    @include ngGrid('desktop');
    padding-top: rem(140px); // grey top margin
    padding-bottom: rem(150px);
  }


  &__column {

    // media query props
    grid-column: span 6;

    @include ngMq($nbp--tablet, up) {
      // grid-column: span 6;
    }

    @include ngMq($nbp--desktop, up) {
      grid-column: span 4;
      // height: rem(840px);
      // margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matter/MatterArticles.vue